import type { SorterResult } from 'antd/es/table/interface'

export type ColumnSortKeys = Record<string, string>

export function resolveBackendSort<T>(
  sorter: SorterResult<T> | SorterResult<T>[],
  columnSortKeys: ColumnSortKeys,
  defaultSort: string,
): string {
  const s = Array.isArray(sorter) ? sorter[0] : sorter
  const key = String(s?.columnKey ?? '')
  const backendKey = columnSortKeys[key]

  if (backendKey && s?.order) {
    return s.order === 'ascend' ? backendKey : `-${backendKey}`
  }

  return defaultSort
}
